'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { splitLangPrefix } from '../i18n/locale';
import { LANGUAGE_DIR } from '../i18n/types';
import { wikiContentLang } from '../i18n/wikiLanguages';

// WHY: на языке без своей вики контент приходит английским — шапка и таб-бар остаются на языке сайта, а тело вики
// получает язык и направление контента; у языка со своей вики они совпадают с оболочкой
export function WikiContentLang({ children }: { children: ReactNode }) {
  const { language } = splitLangPrefix(usePathname());
  const contentLang = language ? wikiContentLang(language) : undefined;
  return (
    <div lang={contentLang} dir={contentLang ? LANGUAGE_DIR[contentLang] : undefined} className="contents">
      {children}
    </div>
  );
}
